'use strict';

const Enum = require('./enum');

/**
 * Defines lock statuses.
 *
 * @enum
 * @readonly
 */
const KeyStatuses = Object.create(Enum, {
  CREATED: { value: 1, enumerable: true },
  LOADED: { value: 2, enumerable: true },
  DELETED: { value: 3, enumerable: true },
});

exports.HomeKitKeyStatuses = KeyStatuses;
